export default __webpack_public_path__ + "static/media/documents1.4999ab9b.svg";